// import { Modal } from 'antd'
import moment from 'moment'
import { modalError } from './modalUtils'
import store from '../redux'
import { redirectURL, clearAuthentication } from './authHelp'
const _ = require('lodash')
const modulesFilesen = require.context('../locale/en', true, /\.js$/)
const modulesen = modulesFilesen.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^.\/(.*)\.js/, '$1')
  const value = modulesFilesen(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
const modulesFileszh = require.context('../locale/zh', true, /\.js$/)
const moduleszh = modulesFileszh.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^.\/(.*)\.js/, '$1')
  const value = modulesFileszh(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
export const languageObj = {
  zh_CN: moduleszh,
  en_US: modulesen
}

export const dateFormatYear = 'YYYY'
export const dateFormatYearMonth = 'YYYY-MM'
export const dateFormatYearMonthDay = 'YYYY-MM-DD'
export const dateFormatYearMonthDayTime1 = 'YYYY-MM-DD HH:mm'
export const dateFormatYearMonthDayTime = 'YYYY-MM-DD HH:mm:ss'

export const formatMessage = (storeState, titles) => {
  let titleList = titles.split('.')
  let resObj = _.cloneDeep(storeState)
  for (let index = 0; index < titleList.length; index++) {
    const element = titleList[index]
    if (resObj[element]) {
      resObj = resObj[element]
    } else {
      resObj = ''
    }
  }
  return resObj.toString()
}

export const formatMessageNew = (titles, storeState) => {
  let titleList = titles.split('.')
  let resObj = {}
  if (storeState) {
    resObj = _.cloneDeep(storeState)
  } else {
    const state = store.getState()
    const commonStore = state.commonStore
    resObj = _.cloneDeep(commonStore)
  }
  for (let index = 0; index < titleList.length; index++) {
    const element = titleList[index]
    if (resObj[element]) {
      resObj = resObj[element]
    } else {
      resObj = ''
    }
  }
  return resObj.toString()
}

// 柯里化
export const initCurryingObj = (list = []) => {
  let obj = {}
  list.forEach(item => {
    obj[item.value] = item.label
    obj[item.label] = item.value
  })
  return obj
}

export const adminPermission = ['Admin']
export const clcFullPermission = ['CLC FULL Operator']
export const clcNddcPermission = ['CLC NDDC Operator']
export const reSendPermission = ['Admin', 'NFC Admin']

export const rfidAdminPermission = ['RFID Admin']
export const rfidRouterPermission1 = ['RFID Admin', 'RFID MPO']
export const rfidRouterPermission2 = ['RFID NSP Store User']
export const rfidRouterPermission3 = ['Admin', 'RFID Admin']
export const defaultRoleList = ['administrator', 'nfc admin', 'rfid admin', 'grey market admin']

export const paginationInit = {
  pageSize: 50,
  currentPage: 1,
  total: 0
}
export const handleChange = (e, obj, cb) => {
  console.log('handleChange')
  console.log('e', e)
  console.log('target', e.target)
  let dt
  let val = e && e.target ? e.target.value : e
  if (Object.prototype.toString.call(obj.state) === '[object Object]') {
    dt = {
      ...obj.state,
      [obj.key]: val && val.trim()
    }
  } else {
    dt = val && val.trim()
  }
  obj.setState(dt)
  cb && cb()
}
export const getQuartersPreOrNext = startDate => {
  let quarterList = getQuarters()
  // let format = 'YYYY-MM-DD HH:mm:ss'
  let de = moment(startDate || undefined)
  let quarter = moment(startDate || undefined)
    .add(0, 'Q')
    .quarter()
  let endVal, startVal
  switch (quarter) {
    case 1:
      startVal = `${de.year() - 1}-12-20 00:00:00`
      endVal = `${de.year()}-03-20 00:00:00`
      break
    case 2:
      startVal = `${de.year()}-03-20 00:00:00`
      endVal = `${de.year()}-06-20 00:00:00`
      break
    case 3:
      startVal = `${de.year()}-06-20 00:00:00`
      endVal = `${de.year()}-09-20 00:00:00`
      break
    case 4:
      startVal = `${de.year()}-09-20 00:00:00`
      endVal = `${de.year()}-12-20 00:00:00`
      break
    default:
      break
  }
  if (de.isAfter(moment(startVal)) && de.isBefore(moment(endVal))) {
    return quarterList[0].value
  } else {
    return quarterList[1].value
  }
}

export const fiscalYearsList = ['Q1', 'Q2', 'Q3', 'Q4']
export const sortFiscalYears = list => {
  let unique = _.sortBy(list, x =>
    _.findIndex(fiscalYearsList, y => {
      return x.value.substring(0, 2) === y
    })
  )
  unique = _.sortBy(unique, item => {
    return -item.value.substring(2, 6)
  })
  return unique
}

export const seasonList = ['SP', 'SU', 'FA', 'HO']
export const sortSeasons = list => {
  let unique = _.sortBy(list, x =>
    _.findIndex(seasonList, y => {
      return x.value.substring(0, 2) === y
    })
  )
  unique = _.sortBy(unique, item => {
    return item.value.substring(2)
  })
  return unique
}
export const getQuarters = (startDate, end = 4, start = 0) => {
  const dateFormat = 'YYYY'
  let seasonDatas = {
    1: 'SP',
    2: 'SU',
    3: 'FA',
    4: 'HO'
  }
  let resSeasons = []
  for (let index = start; index <= end; index++) {
    let item = moment(startDate || undefined).add(index, 'Q')
    let resItem = `${seasonDatas[item.quarter()]}${item.format(dateFormat)}`
    resSeasons.push({
      value: resItem,
      label: resItem
    })
  }
  return resSeasons
}
export const getFiscalYearQuarter = () => {
  let list = []
  let M = moment().month() + 1
  let Y = moment().year() + 1
  if (M >= 6 && M <= 8) {
    list = ['FY' + (Y + '').substring(2, 4) + 'Q1', 'FY' + (Y - 1 + '').substring(2, 4) + 'Q4']
  }
  if (M >= 9 && M <= 11) {
    list = ['FY' + (Y + '').substring(2, 4) + 'Q2', 'FY' + (Y + '').substring(2, 4) + 'Q1']
  }
  if (M === 12 || M <= 2) {
    let Y0 = Y
    if (M === 12) {
    } else {
      Y0 = Y - 1
    }
    list = ['FY' + (Y0 + '').substring(2, 4) + 'Q3', 'FY' + (Y0 + '').substring(2, 4) + 'Q2']
  }
  if (M >= 3 && M <= 5) {
    list = ['FY' + (Y - 1 + '').substring(2, 4) + 'Q4', 'FY' + (Y - 1 + '').substring(2, 4) + 'Q3']
  }
  return initValueAndLabel(list)
}
export const getCRDMonths = (startDate, end = 5, start = 0) => {
  const dateFormat = 'YYYYMM'
  let resSeasons = []
  for (let index = start; index <= end; index++) {
    let item = moment(startDate || undefined)
      .add(index, 'months')
      .format(dateFormat)
    resSeasons.push({
      value: item,
      label: item
    })
  }

  return resSeasons
}
/**
 *
 * @param {*} list {key: key, value: value} Array
 * @param {*} type 1: month, 2: quarter
 * @returns
 */
export const getNowMonth = (list, type = 1) => {
  if (!list || list.length === 0) return
  let now = getCRDMonths()
  if (type === 2) {
    now = getQuarters()
  }
  if (_.find(list, ['value', now[0].value])) {
    return now[0].value
  } else {
    return list[0].value
  }
}
export const downLoadFileBlob = (res, fileName, type = 'application/vnd.ms-excel;charset=utf-8', validateErrorCode) => {
  const reader = new FileReader()
  reader.readAsText(res.data)
  reader.onload = () => {
    try {
      const response = JSON.parse(reader.result)
      console.log(response)
      if (validateErrorCode && validateErrorCode(response.errorCode)) return
      if (response.errorCode === '800') {
        modalError({
          content: formatMessageNew('languageObj.sendLocale.overLimit')
        })
        return
      } else if (response.errorCode === '5001') {
        modalError({
          content: formatMessageNew('languageObj.commonLocale.noDataExport')
        })
        return
      } else if (response.errorCode === '401') {
        modalError(
          {
            content: formatMessageNew('languageObj.httpLocale.tokenInvalid')
          },
          () => {
            clearAuthentication()
            window.location.href = redirectURL
          }
        )
        return
      } else {
        if (res.headers['content-disposition'].indexOf('.json') !== -1) {
          // 抛出异常，在catch中下载json文件
          throw new Error('文件解析失败，直接下载')
        } else {
          modalError({
            content: formatMessageNew('languageObj.httpLocale.requestError')
          })
        }
      }
    } catch (err) {
      // 下载正常处理
      console.log('下载正常处理')
      var downFileName = fileName
      try {
        downFileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
        downFileName = unescape(downFileName)
      } catch {
        console.log('file name is empty')
      }
      let fileArr = downFileName.split('.')
      let extensionName = fileArr[fileArr.length - 1]
      let blob
      if (extensionName === 'zip') {
        blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
      } else if (extensionName === 'json') {
        blob = new Blob([res.data], { type: 'application/json;charset=utf-8' })
      } else {
        blob = new Blob([res.data], { type: type })
      }
      var url = window.URL.createObjectURL(blob)
      var aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = url
      aLink.setAttribute('download', downFileName)
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
      window.URL.revokeObjectURL(url)
    }
  }
}

/**
 * 下载Json工具
 * @param data
 * @param fileName
 */
export const saveAsJson = (str, fileName) => {
  //指定类型文件类型application/json;charset=utf-8
  const blob = new Blob([str], { type: 'application/json;charset=utf-8' })
  const href = URL.createObjectURL(blob)
  const alink = document.createElement('a')
  alink.style.display = 'none'
  alink.download = fileName // 下载后文件名
  alink.href = href
  document.body.appendChild(alink)
  alink.click()
  document.body.removeChild(alink) // 下载完成移除元素
  URL.revokeObjectURL(href) // 释放掉blob对象
}
export const downloadTem = (url, fileName) => {
  const a = document.createElement('a')
  a.download = fileName
  a.href = url
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

/**
 *
 * @list Array{value: T, label: T}||[1,2]
 * @list type类型
 * @key Array {value: T, label: T}时需要排序的字段
 * @returns 去重后的 @list
 */
// 数组去重
export const uniqueFun = (list, type = 1, key = 'value') => {
  let uniqueArr = []
  if (type === 0) {
    // 直接去重
    uniqueArr = _.uniqWith(list, (a, b) => a.value === b.value)
  }
  if (type === 1) {
    // 排序加去重
    uniqueArr = _.uniqWith(
      _.sortBy(list, item => item[key]),
      (a, b) => a.value === b.value
    )
  }
  if (type === 2) {
    // 直接去重
    uniqueArr = _.uniqWith(list, (a, b) => a === b)
  }
  if (type === 3) {
    // 排序后去重
    uniqueArr = _.uniqWith(
      _.sortBy(list, item => item),
      (a, b) => a === b
    )
  }
  return uniqueArr
}

// export const modalError = (message, cb) => {
//   Modal.error({
//     width: 500,
//     title: 'Error',
//     content: message,
//     onOk: () => {
//       cb && cb()
//     }
//   })
// }

export const numFormat = n => {
  let re = /\d{1,3}(?=(\d{3})+$)/g
  let n1 = n
  if (n) {
    n = n.toString()
    n1 = n.replace(/^(\d+)((\.\d+)?)$/, function(s, s1, s2) {
      return s1.replace(re, '$&,') + s2
    })
  }
  return n1
}

export const bigIntegerFormatNike = (num, type = 1) => {
  //type 1: amount 2：quantity
  if (num) {
    if (type === 1) {
      if (num >= 1000000000 || num <= -1000000000) {
        return '$' + numFormat((num / 1000000000).toFixed(1)) + 'B'
      } else if ((num >= 1000000 && num < 1000000000) || (num > -1000000000 && num <= -1000000)) {
        return '$' + numFormat((num / 1000000).toFixed(1)) + 'M'
      } else if ((num < 1000000 && num >= 1000) || (num <= -1000 && num > -1000000)) {
        return '$' + numFormat((num / 1000).toFixed(1)) + 'K'
      } else {
        return '$' + num.toFixed(1)
      }
    } else {
      if ((num >= 1000 && num < 1000000) || (num > -1000000 && num <= -1000)) {
        return numFormat((num / 1000).toFixed(1)) + 'Ku'
      } else if (num >= 1000000 || num <= -1000000) {
        return numFormat((num / 1000000).toFixed(1)) + 'Mu'
      } else {
        return Math.floor(num) + 'u'
      }
    }
  } else if (num === 0 || num === '0') {
    return 0
  } else {
    return '-'
  }
}
export const bigFormatNike = (num, type = 1) => {
  //type 1: amount 2：quantity
  if (num) {
    if (type === 1) {
      return '$' + numFormat(num)
    } else {
      return numFormat(num)
    }
  } else if (num === 0 || num === '0') {
    return 0
  } else {
    return '-'
  }
}
export const selectMonth = () => {
  const list = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const month = moment().month()
  return list[month]
}
/**
 *
 * @param Array
 * @returns Array {value: T, label: T}
 */
export const initValueAndLabel = (list, obj) => {
  if (obj && obj.value) {
    return list.map(item => {
      return {
        value: item[obj.value],
        label: item[obj.label]
      }
    })
  } else {
    return list.map(item => {
      return {
        value: item,
        label: item
      }
    })
  }
}
export const initValueAndText = (list = []) => {
  return list.map(item => {
    return {
      value: item,
      text: item
    }
  })
}
export const uniqueResPush = objMap => {
  let res = []
  if (!objMap) {
    return res
  }
  _.forOwn(objMap, (item, key) => {
    res.push({
      value: key,
      label: key
    })
  })
  return res.filter(item => item.value)
}
export const uniqueResListPush = objMap => {
  let res = []
  if (!objMap) {
    return res
  }
  objMap.filter(Boolean).forEach(item => {
    res.push({
      value: item,
      label: item
    })
  })
  return res
}
export const getLanguage = () => {
  let lang = 'zh_CN'
  if (localStorage.getItem('language') === 'zh_CN' || localStorage.getItem('language') === 'en_US') {
    // 防止莫名出现其他值
    lang = localStorage.getItem('language')
  }
  return lang
}
export const isChineseFun = () => {
  const state = store.getState()
  const commonStore = state.commonStore
  let languageState = commonStore.language === 'zh_CN' ? true : false
  return {
    isChinese: languageState
  }
}

export const openFullscreen = () => {
  /* 获取(<html>)元素以全屏显示页面 */
  // const full = document.getElementsByTagName('body')[0]
  const full = document.documentElement
  if (full.RequestFullScreen) {
    full.RequestFullScreen()
    //兼容Firefox
  } else if (full.mozRequestFullScreen) {
    full.mozRequestFullScreen()
    //兼容Chrome, Safari and Opera等
  } else if (full.webkitRequestFullScreen) {
    full.webkitRequestFullScreen()
    //兼容IE/Edge
  } else if (full.msRequestFullscreen) {
    full.msRequestFullscreen()
  }
}

// export const clickFullscreen = () => {
//   const dom = document.getElementById('zoomInOrOut')
//   dom.click()
// }

export const exitFullscreen = () => {
  // function exitFullscreen() {
  if (document.exitFullScreen) {
    document.exitFullScreen()
    //兼容Firefox
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
    //兼容Chrome, Safari and Opera等
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
    //兼容IE/Edge
  }
  //  else if(element.msExitFullscreen) {
  //      element.msExitFullscreen();
  // }
  // }
}

export const isFullScreen = () => {
  return !!(
    document.fullscreen ||
    document.mozFullScreen ||
    document.webkitIsFullScreen ||
    document.webkitFullScreen ||
    document.msFullScreen
  )
}

export const dateTrans = (date, hm) => {
  let _date = new Date(parseInt(date))
  let y = _date.getFullYear()
  let m = _date.getMonth() + 1
  m = m < 10 ? '0' + m : m
  let d = _date.getDate()
  d = d < 10 ? '0' + d : d
  let h = _date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = _date.getMinutes()
  minute = minute < 10 ? '0' + minute : minute
  if (hm) {
    let dates = y + '-' + m + '-' + d + ' ' + h + ':' + minute
    return dates
  }
  let dates = y + '-' + m + '-' + d
  return dates
}

// 在字符串前面添加N个0 直到指定长度 入参 字符串 指定长度
export const addZero = (str, len) => {
  let zero = new Array(len).join('0')
  let str1 = zero + str
  return str1.slice(-len)
}

export const base64Url = url => {
  if (url) {
    return 'data:image/png;base64,' + url
  } else {
    return ''
  }
}

export const formatStartTime = (date, format = 'YYYY-MM-DD', type = 1) => {
  const start = date && date[0] ? date[0].format(format) : null
  const startTime = start ? start + ' 00:00:00' : start
  return type === 1 ? startTime : start
}

export const formatEndTime = (date, format = 'YYYY-MM-DD', type = 1) => {
  const end = date && date[1] ? date[1].format(format) : null
  const endTime = end ? end + ' 23:59:59' : end
  return type === 1 ? endTime : end
}

export const formatSpcStartTime = (date, format = 'YYYY-MM-DD', type = 1) => {
  if (!date || !date[0]) return null
  // 只取日期部分
  const day = date[0].format('YYYY-MM-DD')
  // 取毫秒部分
  const ms = date[0].format('SSS')
  // 取时区（Z）
  const zone = date[0].format('Z')
  // 你自己传入的 HH:mm
  const time = date[0].format('HH:mm')
  // 秒数默认 00
  return `${day}T${time}:00.${ms}${zone}`
}

export const formatSpcEndTime = (date, format = 'YYYY-MM-DD', type = 1) => {
  if (!date || !date[1]) return null
  const day = date[1].format('YYYY-MM-DD')
  const ms = date[1].format('SSS')
  const zone = date[1].format('Z')
  const time = date[1].format('HH:mm')
  // 秒数默认 59
  return `${day}T${time}:59.${ms}${zone}`
}

export const getPreUrl = port => {
  const origin = window.location.origin
  const url = origin.split(':443')[0] + ':' + port
  return url
}

export const initDateFormat = (de, format = dateFormatYearMonthDay) => {
  console.log('dddd', de)
  console.log(moment(de).format(format))
  return de ? moment(de).format(format) : de
}

export const addPercentage = value => {
  return value ? value + '%' : value
}

export const isMobileFun = () => {
  let userAgent = navigator.userAgent.toLowerCase()
  let isHasMobile = userAgent.includes('mobile')
  return isHasMobile
}

/**
 * 仅支持合并row，tableColumn item中添加onCell
 * 参考页面src\pages\rfid\csc\outboundDetail.js
 * @param dataSource0 数据数组第一个元素 {value: T, label: T}
 * @param dataSource 数据数组 Array {value: T, label: T}
 * @param element 数据数组item {value: T, label: T}
 * @param idx 数据数组下标
 * @param mergeLs 需要合并的字段数组
 */
// 添加处理单元格合并的函数
export const handleRowSpan = (dataSource0, dataSource, element, idx, mergeLs) => {
  for (let index = 0; index < mergeLs.length; index++) {
    const mergeItem = mergeLs[index]
    if (dataSource0[mergeItem] === element[mergeItem]) {
      // 与前一行相同，增加合并行数，当前行不显示
      setRowSpan(dataSource0, dataSource, element, idx, mergeItem)
    } else {
      // 与前一行不同，重置计数
      initRowSpan(dataSource0, dataSource, element, idx, [mergeItem])
    }
  }
}
/**
 * 仅支持合并row
 * 参考页面src\pages\rfid\csc\outboundDetail.js
 * @param dataSource0 数据数组第一个元素 {value: T, label: T}
 * @param dataSource 数据数组 Array {value: T, label: T}
 * @param element 数据数组item {value: T, label: T}
 * @param idx 数据数组下标
 * @param mergeLs 需要合并的字段数组
 */
// 与前一行不同，重置计数
export const initRowSpan = (dataSource0, dataSource, element, idx, mergeLs) => {
  for (let index = 0; index < mergeLs.length; index++) {
    const mergeItem = mergeLs[index]
    let currentRowSpanKey = `currentRowSpan_${mergeItem}`
    let setRowSpanKey = `siteRowSpan_${mergeItem}`
    // 与前一行不同，重置计数
    dataSource0[mergeItem] = element[mergeItem]
    dataSource0[currentRowSpanKey] = 1
    dataSource[idx][setRowSpanKey] = 1
  }
}
/**
 * 仅支持合并row
 * 参考页面src\pages\rfid\csc\outboundDetail.js
 * @param dataSource0 数据数组第一个元素 {value: T, label: T}
 * @param dataSource 数据数组 Array {value: T, label: T}
 * @param element 数据数组item {value: T, label: T}
 * @param idx 数据数组下标
 * @param mergeItem 需要合并的字段key
 */
// 与前一行相同，增加合并行数，当前行不显示
export const setRowSpan = (dataSource0, dataSource, element, idx, mergeItem) => {
  let currentRowSpanKey = `currentRowSpan_${mergeItem}`
  let setRowSpanKey = `siteRowSpan_${mergeItem}`
  let currentRowSpan = (dataSource0[currentRowSpanKey] || 0) + 1
  dataSource0[currentRowSpanKey] = currentRowSpan
  element[setRowSpanKey] = 0
  dataSource[idx - currentRowSpan + 1][setRowSpanKey] = currentRowSpan
}

// 将字符串转换为数组
export const parseToArray = val => {
  if (Array.isArray(val)) {
    return val.map(v => (!v ? '' : String(v).trim())).filter(v => v)
  }
  if (!val) return []
  return String(val)
    .split(/[,\n;，\s]+/)
    .map(v => v.trim())
    .filter(v => v)
}
